<!-- Mobile backdrop -->
@if (mobileOpen()) {
  <div class="sidebar-backdrop" (click)="closeMobile()"></div>
}

<aside
  class="sidebar"
  [class.collapsed]="collapsed()"
  [class.mobile-open]="mobileOpen()"
>
  <!-- Brand -->
  <div class="sidebar-brand">
    <div class="brand-icon">{{ orgShortName.slice(0, 2) }}</div>
    @if (!collapsed()) {
      <span class="brand-text">{{ orgShortName }}</span>
    }
  </div>

  <!-- Navigation -->
  <nav class="sidebar-nav">
    @for (item of navItems; track item.route) {
      <a
        class="nav-item"
        [routerLink]="item.route"
        routerLinkActive="active"
        (click)="closeMobile()"
      >
        <mat-icon class="nav-icon" fontSet="material-icons-outlined">{{ item.icon }}</mat-icon>
        @if (!collapsed()) {
          <span class="nav-label">{{ item.label }}</span>
        }
      </a>
    }
  </nav>

  <!-- Collapse toggle (desktop only) -->
  <div class="sidebar-footer">
    <button class="collapse-btn" (click)="toggleCollapse()">
      <mat-icon fontSet="material-icons-outlined">
        {{ collapsed() ? 'chevron_right' : 'chevron_left' }}
      </mat-icon>
      @if (!collapsed()) {
        <span class="nav-label">Collapse</span>
      }
    </button>
  </div>
</aside>
